import React from 'react';

export const PlanoContext = React.createContext({
  mensagemContato: '',
  setMensagemContato: (mensagem: string) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
});

export function PlanoContextProvider(props: any) {
  const [mensagemContato, setMensagemContato] = React.useState('');

  return (
    <PlanoContext.Provider
      value={{
        mensagemContato,
        setMensagemContato: (mensagem: string) => {
          setMensagemContato(mensagem);
        },
      }}
    >
      {props.children}
    </PlanoContext.Provider>
  );
}
